import { Action } from "../action";
import { NotificationDelay } from "../../components/notifications/notification-delay";

export enum NotificationsActionType {
  SHOW_FAILED_REQUEST = "SHOW_FAILED_REQUEST",
  SHOW_MISSING_NAME = "SHOW_MISSING_NAME",
  SHOW_NOT_FOUND_REQUEST = "SHOW_NOT_FOUND_REQUEST",
  SHOW_SUCCESSFUL_REQUEST = "SHOW_SUCCESSFUL_REQUEST",
}

export interface NotificationMessage {
  message: string;
  variant: "default" | "error" | "success" | "warning" | "info";
  delay: number;
}

export const showFailedRequest = (message?: any): Action<NotificationMessage> => ({
  type: NotificationsActionType.SHOW_FAILED_REQUEST,
  payload: {
    message: message ? message : "Es kam zu einem Fehler!",
    variant: "error",
    delay: NotificationDelay.LONG,
  },
});

export const showSuccessfulRequest = (message: string): Action<NotificationMessage> => ({
  type: NotificationsActionType.SHOW_SUCCESSFUL_REQUEST,
  payload: {
    message,
    variant: "success",
    delay: NotificationDelay.SHORT,
  },
});

export const showMissingName = (): Action<NotificationMessage> => ({
  type: NotificationsActionType.SHOW_FAILED_REQUEST,
  payload: {
    message: "Geben Sie bitte einen Namen ein!",
    variant: "error",
    delay: NotificationDelay.LONG,
  },
});

export const showNotFoundRequest = (): Action<NotificationMessage> => ({
  type: NotificationsActionType.SHOW_NOT_FOUND_REQUEST,
  payload: {
    message: "Zu der Anfrage konnte kein Datensatz gefunden werden!",
    variant: "warning",
    delay: NotificationDelay.DEFAULT,
  },
});
